import { signal, Signal } from '@angular/core';
import { injectMutation, injectQuery } from '@tanstack/angular-query-experimental';

import { FileManagerComponent } from '@shared/components/file-manager/file-manager.component';
import { File } from '@shared/components/file-manager/state/file.model';

export const injectRemoveDocumentMutation = (
  fileManager: Signal<FileManagerComponent | undefined>
) => {
  return injectMutation(() => ({
    mutationFn: (file: File) => {
      return fileManager()!.fileService.remove(file);
    },
  }));
};

export const injectFetchDocument = (
  fileManager: Signal<FileManagerComponent | undefined>,
  path: Signal<string>,
  enabled?: Signal<unknown>
) => {
  const enable: Signal<boolean | unknown> = enabled || signal(true);

  return injectQuery(() => ({
    enabled: !!path() && !!fileManager() && !!enable(),
    queryFn: () => {
      return fileManager()!.fileService.fetchFiles(path());
    },
    queryKey: ['documents', path()],
  }));
};
